export default "__VITE_ASSET__BdFvQ6Vl__"